/* bk-review-links (stranici, 25.10): href на копие → основния продукт, само в отзивите на Judge.me. */
(function () {
  var el = document.getElementById('bk-review-map');
  if (!el) return;
  var map;
  try { map = JSON.parse(el.textContent); } catch (e) { return; }
  var SEL = '[class*="jdgm"] a[href*="/products/"]';
  function rewrite(href) {
    var u = new URL(String(href), location.origin);
    if (u.origin !== location.origin) return href;
    var m = u.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) return href;
    var h;
    try { h = decodeURIComponent(m[1]).toLowerCase(); } catch (e) { h = m[1].toLowerCase(); }
    var main = map[h];
    if (!main) return href;
    u.searchParams.delete('variant'); /* вариантът е на копието, не на основния продукт */
    return location.origin + '/products/' + encodeURIComponent(main) + u.search + u.hash;
  }
  /* Judge.me v2025 (jm-product-variant-card) няма href: отваря продукта с window.open(url, '_blank'). */
  var nativeOpen = window.open;
  window.open = function (url, target, features) {
    if (url) { try { url = rewrite(url); } catch (e) {} }
    return nativeOpen.call(window, url, target, features);
  };
  function fix(a) {
    if (a.dataset.bkRl) return;
    a.dataset.bkRl = '1';
    var u;
    try { u = new URL(a.getAttribute('href'), location.origin); } catch (e) { return; }
    var m = u.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) return;
    var h;
    try { h = decodeURIComponent(m[1]).toLowerCase(); } catch (e) { h = m[1].toLowerCase(); }
    var main = map[h];
    if (!main) return;
    a.setAttribute('href', '/products/' + encodeURIComponent(main) + (u.hash || ''));
  }
  function run(root) {
    var list = (root || document).querySelectorAll(SEL);
    for (var i = 0; i < list.length; i++) fix(list[i]);
  }
  run();
  var t;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 150); })
    .observe(document.body, { childList: true, subtree: true });
})();
